/**
 * Datos estáticos de "Emergencias en ruta".
 *
 * Fuente: información enviada por el cliente ("INFORMACION UTIL RUTA 68 - E.docx").
 * Los números nacionales (Carabineros/SAMU/Bomberos) son estables y no requieren
 * verificación periódica. Los contactos particulares y por comuna sí la requieren
 * — ver `EMERGENCY_DATA_VERIFIED_AT`.
 */

export interface EmergencyPhone {
  label?: string;
  number: string;
}

export interface EmergencyContact {
  title: string;
  description?: string;
  address?: string;
  phones: EmergencyPhone[];
}

export interface EmergencyComuna {
  comuna: string;
  contacts: EmergencyContact[];
}

/** Fecha en que el cliente confirmó estos datos (para el badge de frescura en UI). */
export const EMERGENCY_DATA_VERIFIED_AT = '2026-08-09';

export const NATIONAL_CONTACTS: EmergencyContact[] = [
  { title: 'Carabineros', description: 'Emergencias policiales', phones: [{ number: '133' }] },
  { title: 'SAMU', description: 'Ambulancias', phones: [{ number: '131' }] },
  { title: 'Bomberos', description: 'Incendios y rescate', phones: [{ number: '132' }] },
];

export const ROUTE_68_CONCESSIONAIRE: EmergencyContact = {
  title: 'Concesionaria Ruta 68',
  description: 'Emergencias en la autopista',
  phones: [{ number: '+56 2 2680 0001' }],
};

export const ROUTE_68_SOS_NOTE = 'Postes SOS cada 2 kilómetros a lo largo de la ruta.';

/** Servicios particulares — no son oficiales de la concesionaria ni del Estado. */
export const PRIVATE_ASSISTANCE: EmergencyContact[] = [
  {
    title: 'Grúa particular 24/7',
    description: 'Servicio particular, no oficial',
    phones: [{ number: '+56 9 3378 2088' }],
  },
  {
    title: 'Grúa y auxilio mecánico particular 24/7',
    description: 'Servicio particular, no oficial',
    phones: [{ number: '+56 9 2446 2139' }],
  },
  {
    title: 'Vulcanización y asistencia móvil particular 24/7',
    description: 'Apoyo mecánico básico · servicio particular, no oficial',
    phones: [{ number: '+56 9 4543 8318' }],
  },
];

export const EMERGENCY_COMUNAS: EmergencyComuna[] = [
  {
    comuna: 'Curacaví',
    contacts: [
      {
        title: 'Bomberos',
        address: 'Ambrosio O\'Higgins 231',
        phones: [{ number: '+56 2 2835 2488' }, { number: '+56 2 2835 1050' }],
      },
      {
        title: 'Carabineros',
        address: 'Avda. B. O\'Higgins 211',
        phones: [{ number: '+56 2 2922 6450' }],
      },
      {
        title: 'Carabineros — Tenencia Carretera',
        address: 'Km 48',
        phones: [{ number: '+56 2 2922 4217' }],
      },
      {
        title: 'Hospital Curacaví',
        address: 'Ambrosio O\'Higgins 548',
        phones: [{ number: '+56 2 5745 400' }, { number: '+56 2 2835 1003' }],
      },
    ],
  },
  {
    comuna: 'Casablanca',
    contacts: [
      {
        title: 'Bomberos',
        address: 'Avda. Jaime Galaz 264',
        phones: [{ number: '+56 32 274 2366' }],
      },
      {
        title: 'Carabineros',
        address: 'Membrillar 125',
        phones: [{ number: '+56 32 313 2186' }],
      },
      {
        title: 'Hospital San José',
        address: 'Juan Verdaguer 122',
        phones: [{ number: '+56 32 257 7131' }],
      },
    ],
  },
];
